import {
    DISTRICTLISTAGENTFORPARTNER_SUCCESS,
    DISTRICTLISTAGENTFORPARTNER_FAILED,
    RESET_DISTRICTLISTAGENTFORPARTNER,
    LOADING_DISTRICTLISTAGENTFORPARTNER,
    NETWORK_ERROR_DISTRICTLISTAGENTFORPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DISTRICTLISTAGENTFORPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DISTRICTLISTAGENTFORPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DISTRICTLISTAGENTFORPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DISTRICTLISTAGENTFORPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DISTRICTLISTAGENTFORPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};